/**
 * YEŞİLKÖŞE KAFE - ADMIN PANEL & SUPABASE CLOUD CONFIG
 */

import { store } from './store.js';
import {
  isCloudConnected,
  initSupabaseConfig,
  testTelegramNotification,
  fetchCloudTableCalls,
  fetchCloudEventRequests,
  fetchCloudAdisyons,
  verifyCloudAdminPin
} from './supabaseClient.js';


let isAdminAuthenticated = false;
let activeAdminTab = 'tables'; // 'tables' or 'event_requests'
let activeAdminArea = 'ic-mekan';
let isDeletingEventRequest = false;

export function initAdminPanel() {
  const adminContainer = document.getElementById('adminPanelContainer');
  if (!adminContainer) return;

  if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('yk_admin_auth') === 'true') {
    isAdminAuthenticated = true;
    startAdminLiveHeartbeat();
  }

  renderAdminView();

  window.addEventListener('store-update', () => {
    if (isAdminAuthenticated && !isDeletingEventRequest) {
      renderAdminDashboard();
    }
  });

  window.addEventListener('new-event-request', (e) => {
    if (isAdminAuthenticated) {
      const req = e.detail;
      renderAdminDashboard();
      if (typeof window !== 'undefined' && window.showToast) {
        window.showToast(`🔔 YENİ TEKLİF: ${req.fullName} - ${req.eventTypeName} (${req.guests} Kişi)`, 8000);
      }
    }
  });
}

export function checkAdminAuth() {
  if (!isAdminAuthenticated && typeof sessionStorage !== 'undefined' && sessionStorage.getItem('yk_admin_auth') === 'true') {
    isAdminAuthenticated = true;
    startAdminLiveHeartbeat();
  }
  return isAdminAuthenticated;
}

export async function authenticateAdmin(pin) {
  if (!pin) return false;

  // Supabase PostgreSQL veritabanı üzerinden güvenli doğrulama (Frontend kodunda şifre tutulmaz!)
  const isValid = await verifyCloudAdminPin(pin);
  if (!isValid) {
    return false;
  }

  isAdminAuthenticated = true;
  try {
    sessionStorage.setItem('yk_admin_auth', 'true');
    sessionStorage.setItem('yk_admin_pin', String(pin).trim());
  } catch (_) {}

  if (typeof window !== 'undefined' && 'Notification' in window && Notification.permission === 'default') {
    Notification.requestPermission();
  }
  // Unlock AudioContext on user gesture (browser autoplay policy)
  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (AudioContext) {
      // Unlock store's singleton audio context if it exists
      if (window.store && window.store._audioCtx && window.store._audioCtx.state === 'suspended') {
        window.store._audioCtx.resume().catch(() => {});
      } else {
        // Pre-create and immediately resume a context to warm it up
        const tmpCtx = new AudioContext();
        tmpCtx.resume().then(() => {
          // Play a silent buffer to fully unlock
          const buf = tmpCtx.createBuffer(1, 1, 22050);
          const src = tmpCtx.createBufferSource();
          src.buffer = buf;
          src.connect(tmpCtx.destination);
          src.start(0);
        }).catch(() => {});
      }
    }
  } catch (e) {}

  // Start live polling heartbeat (checks for calls & events every 3.5s without refresh)
  startAdminLiveHeartbeat();

  renderAdminView();
  return true;
}


let livePollingInterval = null;
let isPollingActive = false;

function startAdminLiveHeartbeat() {
  if (livePollingInterval) clearInterval(livePollingInterval);
  performLivePollCheck();
  livePollingInterval = setInterval(performLivePollCheck, 3500);
}

async function performLivePollCheck() {
  if (!isAdminAuthenticated || isPollingActive || isDeletingEventRequest) return;
  isPollingActive = true;

  try {
    // 1. Canlı Masa Çağrıları Kontrolü (Garson & Hesap)
    const cloudCalls = await fetchCloudTableCalls();
    if (cloudCalls && Array.isArray(cloudCalls)) {
      const newCalls = cloudCalls.filter(cc => !store.calls.some(c => String(c.id) === String(cc.id)));
      if (newCalls.length > 0) {
        newCalls.forEach(call => {
          store.calls.unshift(call);
          store.playAlertSound();
          const callTitle = call.type === 'waiter' ? '🛎️ Yeşilköşe - Garson Çağrısı' : '💰 Yeşilköşe - Hesap İstendi';
          const callMsg = `🔔 ${call.tableName.toUpperCase()} ${call.type === 'waiter' ? 'GARSON ÇAĞIRIYOR!' : 'HESAP İSTİYOR!'}`;
          if (typeof window !== 'undefined' && window.showToast) {
            window.showToast(callMsg, 8000);
          }
          if (typeof window !== 'undefined' && 'Notification' in window && Notification.permission === 'granted') {
            try {
              new Notification(callTitle, {
                body: `${call.tableName} • ${call.timestamp}`,
                icon: './src/assets/images/logo.jpg',
                tag: 'call_' + call.id
              });
            } catch (_) {}
          }
        });
        store.save('yk_calls', store.calls);
        renderAdminDashboard();
      }
    }

    // 2. Canlı Organizasyon / Teklif Talepleri Kontrolü (Kına, Nişan, Doğum Günü)
    const cloudEvents = await fetchCloudEventRequests();
    if (cloudEvents && Array.isArray(cloudEvents)) {
      const newEvents = cloudEvents.filter(ce => !store.eventRequests.some(er => String(er.id) === String(ce.id)));
      if (newEvents.length > 0) {
        newEvents.forEach(req => {
          store.eventRequests.unshift(req);
          store.playAlertSound();
          const eventMsg = `🎉 YENİ ORGANİZASYON: ${req.fullName} (${req.guests} Kişi - ${req.eventTypeName || req.eventType})`;
          if (typeof window !== 'undefined' && window.showToast) {
            window.showToast(eventMsg, 9000);
          }
          if (typeof window !== 'undefined' && 'Notification' in window && Notification.permission === 'granted') {
            try {
              new Notification('Yeşilköşe Kafe - Yeni Organizasyon Teklifi!', {
                body: `${req.fullName} • ${req.guests} Kişi • ${req.date}`,
                icon: './src/assets/images/logo.jpg',
                tag: 'event_' + req.id
              });
            } catch (_) {}
          }
          window.dispatchEvent(new CustomEvent('new-event-request', { detail: req }));
        });
        store.save('yk_event_requests', store.eventRequests);
        renderAdminDashboard();
      }
    }

    // 3. Canlı Adisyon Senkronu
    const cloudAdisyons = await fetchCloudAdisyons();
    if (cloudAdisyons && typeof cloudAdisyons === 'object') {
      let changed = false;
      for (const [tableId, adisyonData] of Object.entries(cloudAdisyons)) {
        const current = store.adisyons[tableId];
        if (!current || current.total !== adisyonData.total || (current.items && current.items.length !== (adisyonData.items || []).length)) {
          store.adisyons[tableId] = adisyonData;
          changed = true;
        }
      }
      if (changed) {
        store.save('yk_adisyons', store.adisyons);
        renderAdminDashboard();
      }
    }
  } catch (err) {
    // Network dalgalanmalarında sessizce devam et
  } finally {
    isPollingActive = false;
  }
}



function renderAdminView() {
  const container = document.getElementById('adminPanelContainer');
  if (!container) return;

  if (!isAdminAuthenticated) {
    container.innerHTML = `
      <div class="admin-login-card">
        <div style="width: 64px; height: 64px; border-radius: 50%; background: rgba(19, 75, 59, 0.1); color: var(--emerald-main); display: flex; align-items: center; justify-content: center; font-size: 2rem; margin: 0 auto 16px;">
          <i class="ri-shield-keyhole-line"></i>
        </div>
        <h2 style="font-size: 1.75rem; text-align: center; margin-bottom: 8px;">Gizli Yönetici Girişi</h2>
        <p style="color: var(--text-muted); font-size: 0.9rem; text-align: center; margin-bottom: 24px;">Admin paneline erişmek için yetkili PIN kodunu giriniz.</p>
        
        <form id="adminLoginForm">
          <div class="form-group">
            <input type="password" id="adminPinInput" class="form-input" placeholder="4 Hanesli PIN Kodu" maxlength="6" style="text-align: center; font-size: 1.4rem; letter-spacing: 6px;" required autofocus>
          </div>
          <button type="submit" class="btn btn-primary w-100" style="width: 100%; margin-top: 12px;">
            <i class="ri-lock-unlock-line"></i> Giriş Yap
          </button>
        </form>
      </div>
    `;

    document.getElementById('adminLoginForm')?.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submitBtn = e.target.querySelector('button[type="submit"]');
      const origHtml = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = '<i class="ri-loader-4-line ri-spin"></i> Doğrulanıyor...';
      }

      const pin = document.getElementById('adminPinInput').value;
      const success = await authenticateAdmin(pin);
      if (success) {
        renderAdminDashboard();
      } else {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = origHtml;
        }
        alert('Hatalı PIN Kodu! Lütfen tekrar deneyiniz.');
      }
    });

  } else {
    renderAdminDashboard();
  }
}

function renderAdminDashboard() {
  const container = document.getElementById('adminPanelContainer');
  if (!container) return;

  const activeCalls = store.calls;
  const newEventsCount = store.eventRequests.filter(r => r.status === 'new').length;
  const newTakeawayOrdersCount = (store.onlineOrders || []).filter(o => o.status === 'new').length;

  // Gün Sonu / Kasa Raporu İstatistik Hesaplaması
  const adisyonsList = Object.values(store.adisyons || {});
  const takeawayList = store.onlineOrders || [];
  const takeawayTotalRev = takeawayList.filter(o => o.status !== 'cancelled').reduce((sum, o) => sum + (o.total || 0), 0);

  const totalOrdersCount = adisyonsList.reduce((sum, ad) => sum + (ad.items ? ad.items.reduce((s, i) => s + (i.qty || 1), 0) : 0), 0);
  const totalRevenue = adisyonsList.reduce((sum, ad) => sum + (ad.total || 0), 0) + takeawayTotalRev;

  const productCounts = {};
  adisyonsList.forEach(ad => {
    if (ad.items) {
      ad.items.forEach(i => {
        productCounts[i.name] = (productCounts[i.name] || 0) + i.qty;
      });
    }
  });

  const sortedTopProducts = Object.entries(productCounts)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 3);

  const topProductsText = sortedTopProducts.length > 0
    ? sortedTopProducts.map(([name, count]) => `${name} (${count} Adet)`).join(', ')
    : 'Henüz aktif adisyon yok';

  container.innerHTML = `
    <div class="admin-dashboard-header">
      <div>
        <h2 style="font-size: 2rem; color: var(--emerald-dark); display: flex; align-items: center; gap: 12px;">
          <i class="ri-dashboard-3-line" style="color: var(--gold-accent);"></i> Yönetim Paneli
          <span style="font-size: 0.75rem; padding: 4px 10px; border-radius: var(--radius-full); font-weight: 800; ${isCloudConnected ? 'background: rgba(46,125,50,0.15); color: #2E7D32;' : 'background: rgba(217,83,79,0.15); color: #D9534F;'}">
            ${isCloudConnected ? '⚡ Supabase Bulut Bağlı' : '💾 Yerel Mod (Bulut Bağlanmadı)'}
          </span>
        </h2>
        <p style="color: var(--text-muted); font-size: 0.9rem;">Masa, Paket Sipariş, Adisyon ve Organizasyon Tekliflerini Anlık Takip Edin.</p>
      </div>
      <div style="display: flex; gap: 10px; align-items: center; flex-wrap: wrap;">
        <button class="btn btn-outline" id="toggleOrderingBtn" style="border-color: ${store.isOrderingEnabled ? '#2E7D32' : '#E67E22'}; color: ${store.isOrderingEnabled ? '#2E7D32' : '#E67E22'}; font-weight: 700; background: ${store.isOrderingEnabled ? 'rgba(46,125,50,0.08)' : 'rgba(230,126,34,0.08)'};">
          <i class="${store.isOrderingEnabled ? 'ri-checkbox-circle-line' : 'ri-pause-circle-line'}"></i>
          Online Sipariş: ${store.isOrderingEnabled ? 'AÇIK (Canlıda Aktif)' : 'KAPALI (Gizli)'}
        </button>
        <button class="btn btn-outline" id="supabaseConfigBtn" style="border-color: var(--gold-accent); color: var(--gold-hover);"><i class="ri-cloud-line"></i> Bulut Ayarları</button>
        <button class="btn btn-outline" id="stockMgmtBtn" style="border-color: var(--emerald-main); color: var(--emerald-dark); font-weight: 700;"><i class="ri-restaurant-menu-line" style="color: var(--gold-accent);"></i> Menü & Görsel Düzenle</button>
        <button class="btn btn-outline" id="hardResetAdminBtn" style="border-color: #E67E22; color: #E67E22;"><i class="ri-refresh-line"></i> Önhafızayı Sıfırla</button>
        <button class="btn btn-outline" id="logoutAdminBtn" style="border-color: #D9534F; color: #D9534F;"><i class="ri-logout-box-r-line"></i> Çıkış</button>
      </div>
    </div>

    <!-- 5. GÜN SONU / KASA BİLDİRİMİ WIDGET'I -->
    <div class="report-widget-grid">
      <div class="report-card">
        <div class="report-icon" style="background: rgba(19,75,59,0.1); color: var(--emerald-main);">
          <i class="ri-shopping-cart-2-line"></i>
        </div>
        <div>
          <div class="report-stat-num">${totalOrdersCount} Adet</div>
          <div class="report-stat-label">Masa Adisyon Ürün Adedi</div>
        </div>
      </div>

      <div class="report-card">
        <div class="report-icon" style="background: rgba(212,175,55,0.15); color: var(--gold-accent);">
          <i class="ri-money-dollar-circle-line"></i>
        </div>
        <div>
          <div class="report-stat-num">₺${totalRevenue.toFixed(2)}</div>
          <div class="report-stat-label">Toplam Masa + Paket Ciro</div>
        </div>
      </div>

      <div class="report-card">
        <div class="report-icon" style="background: rgba(46,125,50,0.15); color: #2E7D32;">
          <i class="ri-trophy-line"></i>
        </div>
        <div>
          <div style="font-size: 0.88rem; font-weight: 700; color: var(--emerald-dark);">
            ${topProductsText}
          </div>
          <div class="report-stat-label">En Çok Satanlar (Top 3)</div>
        </div>
      </div>
    </div>

    <!-- Active Calls & Alerts Bar -->
    ${activeCalls.length > 0 ? `
      <div class="alert-bar-live">
        <div style="display: flex; align-items: center; gap: 12px;">
          <span class="pulsing-red-dot"></span>
          <strong style="color: #D9534F; font-size: 1.05rem;">Canlı Garson & Hesap Çağrıları (${activeCalls.length})</strong>
        </div>
        <div class="calls-flex-wrap">
          ${activeCalls.map(c => `
            <div class="call-badge-item">
              <span><strong>${c.tableName}</strong> - ${c.type === 'waiter' ? '🔔 Garson' : (c.type === 'card' ? '💳 Kredi Kartı' : '💵 Nakit Hesap')} <small>(${c.timestamp})</small></span>
              <button class="dismiss-call-btn" data-id="${c.id}"><i class="ri-close-line"></i></button>
            </div>
          `).join('')}
        </div>
      </div>
    ` : ''}

    <!-- New Event Requests Alert Bar -->
    ${newEventsCount > 0 ? `
      <div class="alert-bar-live" style="background: rgba(212,175,55,0.12); border-color: var(--gold-accent); margin-bottom: 20px;">
        <div style="display: flex; align-items: center; justify-content: space-between; width: 100%; flex-wrap: wrap; gap: 10px;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <span class="pulsing-red-dot" style="background: var(--gold-accent);"></span>
            <strong style="color: var(--emerald-dark); font-size: 1.05rem;">🔔 Yeni Organizasyon Teklifi Geldi! (${newEventsCount} Yeni Talep)</strong>
          </div>
          <button class="btn btn-accent" id="btnGoToEventsTab" style="padding: 6px 16px; font-size: 0.85rem; font-weight: 700;">
            Teklifleri İncele <i class="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    ` : ''}

    <!-- Main Navigation Tabs -->
    <div style="display: flex; gap: 12px; margin-bottom: 24px; border-bottom: 2px solid var(--border-light); padding-bottom: 12px; flex-wrap: wrap;">
      <button class="btn ${activeAdminTab === 'tables' ? 'btn-primary' : 'btn-outline'}" id="tabViewTables" style="font-weight: 700;">
        <i class="ri-table-line"></i> Masa & QR Kod Yönetimi
      </button>
      <button class="btn ${activeAdminTab === 'takeaway_orders' ? 'btn-primary' : 'btn-outline'}" id="tabViewTakeaway" style="font-weight: 700; position: relative;">
        <i class="ri-e-bike-2-line"></i> 🛵 Paket Siparişler (Gel-Al / Delivery)
        ${newTakeawayOrdersCount > 0 ? `<span style="background: #D4AF37; color: #000; font-size: 0.75rem; font-weight: bold; padding: 2px 8px; border-radius: 99px; margin-left: 6px;">${newTakeawayOrdersCount} Yeni</span>` : ''}
      </button>
      <button class="btn ${activeAdminTab === 'menu_mgmt' ? 'btn-primary' : 'btn-outline'}" id="tabViewMenu" style="font-weight: 700; ${activeAdminTab === 'menu_mgmt' ? 'background: var(--emerald-dark); border-color: var(--emerald-dark); color: #fff;' : 'border-color: var(--gold-accent); color: var(--emerald-dark);'}">
        <i class="ri-restaurant-menu-line" style="color: var(--gold-accent);"></i> Menü & Görsel Yönetimi
      </button>
      <button class="btn ${activeAdminTab === 'event_requests' ? 'btn-primary' : 'btn-outline'}" id="tabViewEvents" style="font-weight: 700; position: relative;">
        <i class="ri-calendar-event-line"></i> Organizasyon Teklifleri
        ${newEventsCount > 0 ? `<span style="background: #D9534F; color: #fff; font-size: 0.75rem; font-weight: bold; padding: 2px 8px; border-radius: 99px; margin-left: 6px;">${newEventsCount} Yeni</span>` : ''}
      </button>
    </div>

    <!-- Tab View Content -->
    ${activeAdminTab === 'tables' ? renderTablesView() : (activeAdminTab === 'takeaway_orders' ? renderTakeawayOrdersView() : (activeAdminTab === 'menu_mgmt' ? renderMenuView() : renderEventsView()))}
  `;

  // Attach Top-Level Event Listeners
  document.getElementById('toggleOrderingBtn')?.addEventListener('click', () => {
    store.setOrderingEnabled(!store.isOrderingEnabled);
    if (typeof showToast === 'function') {
      showToast(store.isOrderingEnabled ? '🟢 Online sipariş ve sepet sistemi AÇILDI!' : '🟠 Online sipariş sistemi KAPATILDI (Sitede gizlendi).');
    }
    renderAdminDashboard();
  });

  document.getElementById('btnGoToEventsTab')?.addEventListener('click', () => {
    activeAdminTab = 'event_requests';
    renderAdminDashboard();
  });

  document.getElementById('tabViewTables')?.addEventListener('click', () => {
    activeAdminTab = 'tables';
    renderAdminDashboard();
  });

  document.getElementById('tabViewTakeaway')?.addEventListener('click', () => {
    activeAdminTab = 'takeaway_orders';
    renderAdminDashboard();
  });

  document.getElementById('tabViewMenu')?.addEventListener('click', () => {
    activeAdminTab = 'menu_mgmt';
    renderAdminDashboard();
  });

  document.getElementById('tabViewEvents')?.addEventListener('click', () => {
    activeAdminTab = 'event_requests';
    renderAdminDashboard();
  });

  document.querySelectorAll('.btn-takeaway-filter').forEach(btn => {
    btn.addEventListener('click', (e) => {
      takeawayFilterStatus = e.currentTarget.getAttribute('data-status');
      renderAdminDashboard();
    });
  });

  document.querySelectorAll('.btn-status-change').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const id = e.currentTarget.getAttribute('data-id');
      const st = e.currentTarget.getAttribute('data-status');
      store.updateOnlineOrderStatus(id, st);
      renderAdminDashboard();
    });
  });

  document.querySelectorAll('.btn-delete-online-order').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const id = e.currentTarget.getAttribute('data-id');
      if (confirm('Bu paket siparişi silmek istediğinize emin misiniz?')) {
        store.deleteOnlineOrder(id);
        renderAdminDashboard();
      }
    });
  });

  document.querySelectorAll('.dismiss-call-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const callId = Number(e.currentTarget.getAttribute('data-id'));
      store.dismissCall(callId);
      renderAdminDashboard();
    });
  });

  document.getElementById('supabaseConfigBtn')?.addEventListener('click', openSupabaseConfigModal);
  document.getElementById('stockMgmtBtn')?.addEventListener('click', () => {
    activeAdminTab = 'menu_mgmt';
    renderAdminDashboard();
  });

  document.getElementById('hardResetAdminBtn')?.addEventListener('click', () => {
    if (confirm('Tüm önhafıza ve yerel veriler temizlenip menü sıfırlanacak. Devam edilsin mi?')) {
      store.hardReset();
      alert('✅ Önhafıza temizlendi ve güncel veriler yeniden yüklendi!');
      renderAdminDashboard();
    }
  });

  document.getElementById('logoutAdminBtn')?.addEventListener('click', () => {
    isAdminAuthenticated = false;
    renderAdminView();
  });
}

let adminMenuFilterCat = 'all';
let adminMenuSearchQuery = '';

function renderMenuView() {
  const products = store.products || [];
  const categories = store.categories || [];
  const filtered = products.filter(item => {
    const matchesCat = adminMenuFilterCat === 'all' || item.category === adminMenuFilterCat;
    const q = adminMenuSearchQuery.toLowerCase();
    const matchesName = item.name ? item.name.toLowerCase().includes(q) : false;
    const matchesDesc = item.desc ? item.desc.toLowerCase().includes(q) : false;
    return matchesCat && (matchesName || matchesDesc);
  });

  setTimeout(() => {
    const searchInp = document.getElementById('adminMenuSearchInput');
    if (searchInp) {
      searchInp.value = adminMenuSearchQuery;
      searchInp.addEventListener('input', (e) => {
        adminMenuSearchQuery = e.target.value;
        renderAdminDashboard();
      });
    }

    document.querySelectorAll('.admin-menu-cat-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        adminMenuFilterCat = e.currentTarget.getAttribute('data-category');
        renderAdminDashboard();
      });
    });

    document.querySelectorAll('.edit-product-btn-inline').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const prodId = e.currentTarget.getAttribute('data-id');
        openEditProductModal(prodId);
      });
    });

    document.querySelectorAll('.inline-price-input').forEach(inp => {
      inp.addEventListener('change', (e) => {
        const prodId = e.target.getAttribute('data-id');
        const newPrice = Number(e.target.value) || 0;
        store.updateProduct(prodId, { price: newPrice });
        if (typeof showToast === 'function') {
          showToast(`💰 Ürün fiyatı ₺${newPrice.toFixed(2)} olarak güncellendi!`);
        }
      });
    });

    document.querySelectorAll('.inline-stock-checkbox').forEach(chk => {
      chk.addEventListener('change', (e) => {
        const prodId = e.target.getAttribute('data-id');
        store.toggleStock(prodId);
        renderAdminDashboard();
      });
    });

    // --- ÜRÜN EKLEME & SİLME DİNLEYİCİLERİ ---
    document.getElementById('addNewProductBtn')?.addEventListener('click', () => {
      openEditProductModal(null);
    });

    document.querySelectorAll('.delete-product-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const prodId = e.currentTarget.getAttribute('data-id');
        const prodName = e.currentTarget.getAttribute('data-name') || 'Bu ürün';
        if (confirm(`"${prodName}" ürününü menüden tamamen silmek istediğinize emin misiniz?`)) {
          store.deleteProduct(prodId);
          if (typeof showToast === 'function') {
            showToast(`🗑️ "${prodName}" menüden silindi.`);
          }
          renderAdminDashboard();
        }
      });
    });

    // --- KATEGORİ YÖNETİMİ ---
    document.getElementById('addCategoryBtn')?.addEventListener('click', () => {
      const emoji = prompt('Emoji seçin (örn: 🍕, 🥗, 🍺 — boş bırakabilirsiniz):', '🍽️') ?? '🍽️';
      const name = prompt('Yeni kategori adı girin (örn: Atıştırmalıklar):');
      if (name && name.trim()) {
        store.addCategory(name.trim(), emoji.trim() || '🍽️');
        if (typeof showToast === 'function') showToast(`✅ "${name.trim()}" kategorisi eklendi!`);
        renderAdminDashboard();
      }
    });

    document.querySelectorAll('.rename-cat-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const catId = e.currentTarget.getAttribute('data-cat-id');
        const cat = store.categories.find(c => c.id === catId);
        if (!cat) return;
        const newEmoji = prompt('Yeni emoji (boş bırakırsanız mevcut kalır):', cat.emoji) ?? cat.emoji;
        const newName = prompt(`"${cat.name}" kategorisinin yeni adı:`, cat.name);
        if (newName && newName.trim()) {
          store.renameCategory(catId, newName.trim(), newEmoji.trim() || cat.emoji);
          if (typeof showToast === 'function') showToast(`✏️ Kategori "${newName.trim()}" olarak güncellendi!`);
          renderAdminDashboard();
        }
      });
    });

    document.querySelectorAll('.delete-cat-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const catId = e.currentTarget.getAttribute('data-cat-id');
        const cat = store.categories.find(c => c.id === catId);
        if (!cat) return;
        const productCount = store.products.filter(p => p.category === cat.name).length;
        const msg = productCount > 0
          ? `"${cat.name}" kategorisinde ${productCount} ürün var. Bu ürünler "Diğer" kategorisine taşınacak. Devam etmek istiyor musunuz?`
          : `"${cat.name}" kategorisini silmek istediğinizden emin misiniz?`;
        if (confirm(msg)) {
          store.deleteCategory(catId);
          if (adminMenuFilterCat === cat.name) adminMenuFilterCat = 'all';
          if (typeof showToast === 'function') showToast(`🗑️ "${cat.name}" kategorisi silindi.`);
          renderAdminDashboard();
        }
      });
    });
  }, 0);

  return `
    <div style="background: var(--bg-card); padding: 24px; border-radius: var(--radius-lg); border: 1px solid var(--border-light); box-shadow: var(--shadow-md);">
      <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 16px; margin-bottom: 24px;">
        <div>
          <h3 style="font-size: 1.4rem; color: var(--emerald-dark); margin-bottom: 4px;">
            <i class="ri-restaurant-menu-line" style="color: var(--gold-accent);"></i> Menü & Ürün Yönetimi
          </h3>
          <p style="color: var(--text-muted); font-size: 0.88rem; margin: 0;">Yeni ürün ekleyin, silin, fotoğraflarını yükleyin, fiyatları ve stok durumlarını doğrudan yönetin.</p>
        </div>
        <div style="display: flex; gap: 10px; align-items: center; flex-wrap: wrap;">
          <input type="text" id="adminMenuSearchInput" class="form-input" placeholder="Ürün ara..." style="padding: 10px 16px; font-size: 0.9rem; min-width: 200px;">
          <button class="btn btn-primary" id="addNewProductBtn" style="padding: 10px 18px; font-size: 0.9rem; font-weight: 700; display: flex; align-items: center; gap: 6px; white-space: nowrap;">
            <i class="ri-add-circle-fill" style="font-size: 1.1rem;"></i> Yeni Ürün Ekle
          </button>
        </div>
      </div>

      <!-- KATEGORİ YÖNETİMİ PANELİ -->
      <div style="background: var(--bg-cream); border: 1px solid var(--border-light); border-radius: var(--radius-md); padding: 16px; margin-bottom: 20px;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; flex-wrap: wrap; gap: 8px;">
          <span style="font-weight: 700; font-size: 0.95rem; color: var(--emerald-dark);">
            <i class="ri-list-settings-line" style="color: var(--gold-accent);"></i> Kategori Yönetimi
          </span>
          <button class="btn btn-primary" id="addCategoryBtn" style="padding: 6px 14px; font-size: 0.82rem;">
            <i class="ri-add-circle-line"></i> Yeni Kategori Ekle
          </button>
        </div>
        <div style="display: flex; flex-wrap: wrap; gap: 8px;">
          ${categories.map(cat => {
            const count = products.filter(p => p.category === cat.name).length;
            return `
              <div style="display: flex; align-items: center; gap: 6px; background: #fff; border: 1px solid var(--border-light); border-radius: var(--radius-full); padding: 5px 10px; font-size: 0.82rem;">
                <span>${cat.emoji} ${cat.name}</span>
                <span style="color: var(--text-muted); font-size: 0.75rem;">(${count})</span>
                <button class="rename-cat-btn" data-cat-id="${cat.id}" title="Yeniden Adlandır" style="background: none; border: none; cursor: pointer; color: var(--emerald-main); padding: 2px 4px; font-size: 0.8rem;">
                  <i class="ri-pencil-line"></i>
                </button>
                <button class="delete-cat-btn" data-cat-id="${cat.id}" title="Sil" style="background: none; border: none; cursor: pointer; color: #D9534F; padding: 2px 4px; font-size: 0.8rem;">
                  <i class="ri-close-line"></i>
                </button>
              </div>
            `;
          }).join('')}
        </div>
      </div>

      <!-- Kategori Filtre Butonları -->
      <div style="display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 24px;">
        <button class="btn ${adminMenuFilterCat === 'all' ? 'btn-primary' : 'btn-outline'} admin-menu-cat-btn" data-category="all" style="padding: 6px 14px; font-size: 0.82rem;">Tüm Ürünler (${products.length})</button>
        ${categories.map(cat => `
          <button class="btn ${adminMenuFilterCat === cat.name ? 'btn-primary' : 'btn-outline'} admin-menu-cat-btn" data-category="${cat.name}" style="padding: 6px 14px; font-size: 0.82rem;">${cat.emoji} ${cat.name}</button>
        `).join('')}
      </div>

      <!-- Product Cards Grid -->
      <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(340px, 1fr)); gap: 16px;">
        ${filtered.map(p => `
          <div style="display: flex; gap: 14px; padding: 14px; background: var(--bg-cream); border-radius: var(--radius-md); border: 1px solid var(--border-light); align-items: center; position: relative;">
            <img src="${p.imageUrl || p.image || './src/assets/images/hero-coffee.jpg'}" alt="${p.name}" style="width: 80px; height: 80px; object-fit: cover; border-radius: var(--radius-sm); border: 1px solid var(--border-light); flex-shrink: 0;" onerror="this.onerror=null;this.src='./src/assets/images/hero-coffee.jpg';">
            
            <div style="flex: 1; min-width: 0;">
              <div style="font-weight: 700; font-size: 0.98rem; color: var(--emerald-dark); margin-bottom: 2px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">${p.name}</div>
              
              <div style="display: flex; gap: 6px; align-items: center; margin-bottom: 6px;">
                <span style="font-size: 0.8rem; font-weight: 700; color: var(--text-muted);">₺</span>
                <input type="number" step="0.5" class="inline-price-input" data-id="${p.id}" value="${p.price}" title="Anlık Fiyat Güncelle">
                <span style="font-size: 0.75rem; color: var(--text-muted);">(${p.category})</span>
              </div>

              <div style="display: flex; gap: 8px; align-items: center;">
                <label class="stock-switch" title="${p.isOutOfStock ? 'Tükendi' : 'Stokta'}">
                  <input type="checkbox" class="inline-stock-checkbox" data-id="${p.id}" ${p.isOutOfStock ? 'checked' : ''}>
                  <span class="stock-slider"></span>
                </label>
                <span style="font-size: 0.78rem; font-weight: 800; color: ${p.isOutOfStock ? '#D9534F' : '#2E7D32'};">
                  ${p.isOutOfStock ? '⚠️ TÜKENDİ' : '✅ STOKTA'}
                </span>
              </div>
            </div>

            <div style="display: flex; flex-direction: column; gap: 6px; flex-shrink: 0;">
              <button class="btn btn-primary edit-product-btn-inline" data-id="${p.id}" style="padding: 6px 12px; font-size: 0.78rem;" title="Ürün Bilgilerini & Görselini Düzenle">
                <i class="ri-edit-line"></i> Düzenle
              </button>
              <button class="btn btn-outline delete-product-btn" data-id="${p.id}" data-name="${p.name}" style="padding: 6px 12px; font-size: 0.78rem; color: #D9534F; border-color: #D9534F;" title="Ürünü Menüden Sil">
                <i class="ri-delete-bin-line"></i> Sil
              </button>
            </div>
          </div>
        `).join('')}
      </div>
    </div>
  `;
}


function renderTablesView() {
  const areaTables = store.tables.filter(t => t.areaId === activeAdminArea);

  setTimeout(() => {
    document.querySelectorAll('.admin-area-tab').forEach(tab => {
      tab.addEventListener('click', (e) => {
        activeAdminArea = e.currentTarget.getAttribute('data-area');
        renderAdminDashboard();
      });
    });

    document.querySelectorAll('.copy-qr-url-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const url = e.currentTarget.getAttribute('data-url');
        navigator.clipboard.writeText(url).then(() => alert(`QR Linki Panoya Kopyalandı!\n${url}`));
      });
    });

    document.querySelectorAll('.download-qr-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const qrUrl = e.currentTarget.getAttribute('data-url');
        const tableName = e.currentTarget.getAttribute('data-name');
        downloadQRCodeImage(qrUrl, tableName);
      });
    });

    document.querySelectorAll('.print-qr-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const qrUrl = e.currentTarget.getAttribute('data-url');
        const tableName = e.currentTarget.getAttribute('data-name');
        printTableQRCardWindow(tableName, qrUrl);
      });
    });

    document.querySelectorAll('.relocate-select').forEach(sel => {
      sel.addEventListener('change', (e) => {
        store.moveTable(e.target.getAttribute('data-table-id'), e.target.value);
        renderAdminDashboard();
      });
    });

    document.querySelectorAll('.open-adisyon-btn').forEach(btn => {
      btn.addEventListener('click', (e) => openAdisyonModal(e.currentTarget.getAttribute('data-table-id')));
    });

    document.querySelectorAll('.delete-table-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const tblId = e.currentTarget.getAttribute('data-id');
        if (confirm('Bu masayı silmek istediğinizden emin misiniz?')) {
          store.deleteTable(tblId);
          renderAdminDashboard();
        }
      });
    });

    document.getElementById('addNewTableBtn')?.addEventListener('click', () => {
      const name = prompt('Yeni Masa Adı (Örn: Masa 31, Bahçe 5, VIP Loca 2):');
      if (name) {
        store.addTable(name, activeAdminArea);
        renderAdminDashboard();
      }
    });
  }, 0);

  return `
    <div class="admin-area-tabs" style="margin-bottom: 20px; display: flex; gap: 12px; flex-wrap: wrap;">
      ${store.areas.map(area => {
        const count = store.tables.filter(t => t.areaId === area.id).length;
        const activeCount = store.tables.filter(t => t.areaId === area.id && (t.status === 'occupied' || store.calls.some(c => c.tableId === t.id))).length;
        return `
          <button class="admin-area-tab ${area.id === activeAdminArea ? 'active' : ''}" data-area="${area.id}">
            <i class="${area.icon}"></i> ${area.name} (${activeCount}/${count} Dolu)
          </button>
        `;
      }).join('')}
      <button class="btn btn-primary" id="addNewTableBtn" style="margin-left: auto; padding: 8px 16px; font-size: 0.88rem;">
        <i class="ri-add-circle-line"></i> Yeni Masa Ekle
      </button>
    </div>

    <div class="admin-tables-grid">
      ${areaTables.map(tbl => {
        const adisyon = store.adisyons[tbl.id];
        const hasCall = store.calls.some(c => c.tableId === tbl.id);
        const callDetails = store.calls.filter(c => c.tableId === tbl.id);
        const isOccupied = tbl.status === 'occupied' || (adisyon && adisyon.items && adisyon.items.length > 0);
        const qrTargetUrl = `${window.location.origin}${window.location.pathname}?t=${tbl.token}`;
        const qrImageUrl = `https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${encodeURIComponent(qrTargetUrl)}`;

        const adisyonItemsSummary = (adisyon && adisyon.items && adisyon.items.length > 0)
          ? adisyon.items.map(i => `${i.qty}x ${i.name}`).join(', ')
          : null;

        return `
          <div class="table-card-admin ${isOccupied ? 'occupied' : 'empty'} ${hasCall ? 'has-alert' : ''}" data-table-id="${tbl.id}">
            <div class="table-card-header">
              <span class="table-name-badge"><i class="ri-table-line"></i> ${tbl.name}</span>
              <span class="table-status-pill ${isOccupied ? 'status-occupied' : 'status-empty'}">
                ${isOccupied ? 'Dolu' : 'Boş'}
              </span>
            </div>

            ${hasCall ? `
              <div class="table-alert-banner">
                <i class="ri-alarm-warning-line"></i> ${callDetails.map(cd => cd.type === 'waiter' ? 'Garson Çağırıyor' : 'Hesap İsteniyor').join(', ')}
              </div>
            ` : ''}

            <!-- 2. CANLI SİPARİŞ & ADİSYON ÖZETİ -->
            <div class="table-card-body" style="padding: 10px 0;">
              ${adisyonItemsSummary ? `
                <div style="font-size: 0.85rem; font-weight: 700; color: var(--emerald-dark); margin-bottom: 4px; line-height: 1.4;">
                  📋 ${adisyonItemsSummary}
                </div>
                <div class="table-total-amount" style="font-size: 1.3rem; font-weight: 800; color: var(--emerald-main);">
                  ₺${adisyon.total.toFixed(2)}
                </div>
              ` : `
                <div style="font-size: 0.85rem; color: var(--text-muted); padding: 8px 0;">Masa Boş (Sipariş Yok)</div>
              `}
            </div>

            <!-- 3. MASA VE QR KOD OLUŞTURUCU & İNDİRİCİ -->
            <div style="display: flex; gap: 10px; align-items: center; margin-bottom: 12px; background: #fff; padding: 8px; border-radius: var(--radius-sm); border: 1px solid var(--border-light);">
              <img src="${qrImageUrl}" alt="${tbl.name} QR Kod" style="width: 64px; height: 64px; border-radius: var(--radius-sm); object-fit: contain; flex-shrink: 0; border: 1px solid var(--border-light);">
              <div style="display: flex; flex-direction: column; gap: 4px; flex: 1;">
                <button class="btn btn-outline download-qr-btn" data-url="${qrImageUrl}" data-name="${tbl.name}" style="padding: 4px 8px; font-size: 0.75rem; border-color: var(--emerald-main); color: var(--emerald-main);">
                  <i class="ri-download-2-line"></i> QR PNG İndir
                </button>
                <button class="btn btn-outline print-qr-btn" data-url="${qrImageUrl}" data-name="${tbl.name}" style="padding: 4px 8px; font-size: 0.75rem; border-color: var(--gold-accent); color: var(--gold-hover);">
                  <i class="ri-printer-line"></i> Kartı Yazdır
                </button>
              </div>
            </div>

            <div class="table-card-actions" style="display: flex; gap: 6px; flex-wrap: wrap;">
              <button class="btn btn-primary open-adisyon-btn" style="padding: 6px 12px; font-size: 0.8rem; flex: 1;" data-table-id="${tbl.id}">
                <i class="ri-file-list-3-line"></i> Adisyon (${adisyon && adisyon.items ? adisyon.items.length : 0})
              </button>
              <select class="relocate-select" data-table-id="${tbl.id}" style="padding: 4px 8px; font-size: 0.75rem; border-radius: var(--radius-sm); border: 1px solid var(--border-light);">
                ${store.areas.map(a => `<option value="${a.id}" ${a.id === tbl.areaId ? 'selected' : ''}>Taşı: ${a.name}</option>`).join('')}
              </select>
              <button class="btn btn-outline delete-table-btn" data-id="${tbl.id}" style="padding: 4px 8px; font-size: 0.75rem; border-color: #D9534F; color: #D9534F;" title="Masayı Sil">
                <i class="ri-delete-bin-line"></i>
              </button>
            </div>
          </div>
        `;
      }).join('')}
    </div>
  `;
}

function downloadQRCodeImage(qrUrl, tableName) {
  fetch(qrUrl)
    .then(res => res.blob())
    .then(blob => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `Yesilkose_${tableName.replace(/\s+/g, '_')}_QR.png`;
      a.click();
    })
    .catch(() => alert('QR resim indirme hatası. Bağlantınızı kontrol ediniz.'));
}

function printTableQRCardWindow(tableName, qrUrl) {
  const printWindow = window.open('', '_blank', 'width=600,height=700');
  if (!printWindow) return;

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>Masa QR Kartı - ${tableName}</title>
      <style>
        body { font-family: 'Plus Jakarta Sans', sans-serif; text-align: center; padding: 40px; background: #FAF7F2; color: #1A2421; }
        .card { border: 3px solid #134B3B; border-radius: 24px; padding: 36px; max-width: 380px; margin: 0 auto; background: #FFF; box-shadow: 0 10px 30px rgba(0,0,0,0.1); }
        h1 { color: #134B3B; margin-bottom: 2px; font-size: 24px; letter-spacing: 1px; }
        h2 { color: #D4AF37; margin-top: 0; font-size: 28px; }
        img { margin: 20px 0; border: 2px solid #134B3B; border-radius: 16px; padding: 8px; background: #FFF; }
        p { color: #5C6E67; font-size: 14px; font-weight: 600; line-height: 1.5; }
      </style>
    </head>
    <body>
      <div class="card">
        <h1>YEŞİLKÖŞE KAFE</h1>
        <h2>${tableName}</h2>
        <img src="${qrUrl}" width="220" height="220">
        <p>📱 Menüyü incelemek ve masanızdan sipariş vermek için telefon kameranızla QR kodu okutunuz.</p>
      </div>
      <script>window.onload = () => { window.print(); window.close(); };</script>
    </body>
    </html>
  `);
  printWindow.document.close();
}

function renderEventsView() {
  const requests = store.eventRequests;

  const statusBadges = {
    new: { label: '🟡 Yeni Gelen', bg: '#FFF8E1', color: '#B78103' },
    reviewed: { label: '🔵 İncelendi', bg: '#E3F2FD', color: '#1565C0' },
    contacted: { label: '🟣 Müşteri Arandı', bg: '#F3E5F5', color: '#7B1FA2' },
    approved: { label: '🟢 Anlaşıldı / Onaylandı', bg: '#E8F5E9', color: '#2E7D32' },
    cancelled: { label: '🔴 İptal / Olumsuz', bg: '#FFEBEE', color: '#C62828' }
  };

  setTimeout(() => {
    document.querySelectorAll('.event-status-select').forEach(sel => {
      sel.addEventListener('change', (e) => {
        const reqId = e.target.getAttribute('data-id');
        const newStatus = e.target.value;
        store.updateEventRequestStatus(reqId, newStatus);
        renderAdminDashboard();
      });
    });

    document.querySelectorAll('.delete-event-req-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (isDeletingEventRequest) return;
        const reqId = e.currentTarget.getAttribute('data-id');
        const reqItem = store.eventRequests.find(r => r.id === reqId);
        if (!reqItem) return;

        openDeleteConfirmModal(reqItem);
      });
    });
  }, 0);

  return `
    <div>
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
        <h3 style="font-size: 1.5rem; color: var(--emerald-dark);">Gelen Organizasyon & Etkinlik Teklifleri (${requests.length})</h3>
        <span style="font-size: 0.88rem; color: var(--text-muted);">Tarih sırasına göre listelenmektedir.</span>
      </div>

      ${requests.length === 0 ? `
        <div style="background: var(--bg-card); padding: 48px; border-radius: var(--radius-md); text-align: center; color: var(--text-muted); border: 1px solid var(--border-light);">
          <i class="ri-calendar-event-line" style="font-size: 3rem; display: block; margin-bottom: 12px; color: var(--gold-accent);"></i>
          <h4 style="font-size: 1.2rem; color: var(--text-dark); margin-bottom: 6px;">Henüz gelen organizasyon teklifi bulunmamaktadır.</h4>
          <p style="font-size: 0.88rem; color: var(--text-muted);">Yeni teklif talepleri geldiğinde bu ekranda anlık olarak listelenecektir.</p>
        </div>
      ` : `
        <div style="display: flex; flex-direction: column; gap: 16px;">
          ${requests.map(req => {
            const st = statusBadges[req.status] || statusBadges.new;
            const cleanPhone = req.phone ? req.phone.replace(/\s+/g, '') : '';
            return `
              <div style="background: var(--bg-card); border-radius: var(--radius-md); border: 1px solid var(--border-light); padding: 24px; box-shadow: var(--shadow-sm); display: flex; flex-direction: column; gap: 16px;">
                <div style="display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap; gap: 12px; border-bottom: 1px dashed var(--border-light); padding-bottom: 12px;">
                  <div>
                    <div style="display: flex; align-items: center; gap: 10px;">
                      <h4 style="font-size: 1.25rem; color: var(--text-dark);">${req.fullName}</h4>
                      <span style="background: ${st.bg}; color: ${st.color}; font-weight: 800; font-size: 0.75rem; padding: 4px 12px; border-radius: var(--radius-full);">
                        ${st.label}
                      </span>
                    </div>
                    <div style="font-size: 0.85rem; color: var(--text-muted); margin-top: 4px;">
                      <i class="ri-time-line"></i> Başvuru Tarihi: ${req.createdAt} | <i class="ri-calendar-check-line"></i> Planlanan Etkinlik Tarihi: <strong>${req.date}</strong>
                    </div>
                  </div>

                  <div style="display: flex; gap: 8px; align-items: center;">
                    <a href="tel:${cleanPhone}" class="btn btn-outline" style="padding: 6px 12px; font-size: 0.8rem;" title="Müşteriyi Ara">
                      <i class="ri-phone-fill"></i> ${req.phone}
                    </a>
                    <a href="https://wa.me/${cleanPhone.replace(/^0/, '90')}" target="_blank" class="btn btn-accent" style="padding: 6px 12px; font-size: 0.8rem;" title="WhatsApp İle Yaz">
                      <i class="ri-whatsapp-line"></i> WhatsApp
                    </a>
                    <button class="btn btn-outline delete-event-req-btn" data-id="${req.id}" style="padding: 6px 10px; font-size: 0.8rem; border-color: #D9534F; color: #D9534F;" title="Teklifi Sil">
                      <i class="ri-delete-bin-line"></i>
                    </button>
                  </div>
                </div>

                <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 16px; background: rgba(19,75,59,0.03); padding: 16px; border-radius: var(--radius-sm);">
                  <div>
                    <span style="font-size: 0.8rem; color: var(--text-muted); display: block;">Etkinlik Türü</span>
                    <strong style="color: var(--emerald-dark); font-size: 1rem;">${req.eventTypeName}</strong>
                  </div>
                  <div>
                    <span style="font-size: 0.8rem; color: var(--text-muted); display: block;">Tahmini Katılımcı</span>
                    <strong style="color: var(--emerald-dark); font-size: 1rem;">${req.guests} Kişi</strong>
                  </div>
                  <div>
                    <span style="font-size: 0.8rem; color: var(--text-muted); display: block;">Durum Güncelle</span>
                    <select class="form-input event-status-select" data-id="${req.id}" style="padding: 4px 8px; font-size: 0.85rem; font-weight: bold; background: #fff;">
                      <option value="new" ${req.status === 'new' ? 'selected' : ''}>🟡 Yeni Gelen</option>
                      <option value="reviewed" ${req.status === 'reviewed' ? 'selected' : ''}>🔵 İncelendi</option>
                      <option value="contacted" ${req.status === 'contacted' ? 'selected' : ''}>🟣 Müşteri Arandı</option>
                      <option value="approved" ${req.status === 'approved' ? 'selected' : ''}>🟢 Anlaşıldı / Onaylandı</option>
                      <option value="cancelled" ${req.status === 'cancelled' ? 'selected' : ''}>🔴 İptal / Olumsuz</option>
                    </select>
                  </div>
                </div>

                ${req.notes ? `
                  <div style="font-size: 0.9rem; color: var(--text-dark); background: var(--bg-cream); padding: 12px 16px; border-radius: var(--radius-sm); border-left: 3px solid var(--gold-accent);">
                    <strong>Müşteri Notu:</strong> ${req.notes}
                  </div>
                ` : ''}
              </div>
            `;
          }).join('')}
        </div>
      `}
    </div>
  `;
}

function openSupabaseConfigModal() {
  const backdrop = document.getElementById('modalBackdrop');
  const modalBody = document.getElementById('modalBody');
  if (!backdrop || !modalBody) return;

  const currentUrl = localStorage.getItem('yk_supabase_url') || '';
  const currentKey = localStorage.getItem('yk_supabase_key') || '';
  const currentTelegramToken = localStorage.getItem('yk_telegram_bot_token') || '';
  const currentTelegramChatId = localStorage.getItem('yk_telegram_chat_id') || '';

  modalBody.innerHTML = `
    <h3 style="margin-bottom: 8px; font-size: 1.5rem; color: var(--emerald-dark);">⚡ Bulut & Bildirim Ayarları</h3>
    <p style="color: var(--text-muted); font-size: 0.88rem; margin-bottom: 20px;">
      Supabase bulut veritabanı ve işletme sahibine anlık bildirim gönderecek Telegram botunu buradan yapılandırabilirsiniz.
    </p>

    <form id="supabaseConfigForm">
      <div style="background: rgba(19,75,59,0.04); border: 1px solid var(--border-light); border-radius: var(--radius-md); padding: 16px; margin-bottom: 20px;">
        <h4 style="font-size: 1rem; color: var(--emerald-main); margin-bottom: 12px; display: flex; align-items: center; gap: 8px;">
          <i class="ri-database-2-line"></i> Supabase Bulut Veritabanı
        </h4>
        <div class="form-group">
          <label class="form-label">Supabase Project URL</label>
          <input type="url" id="sbUrlInput" class="form-input" placeholder="https://YOUR_PROJECT_ID.supabase.co" value="${currentUrl}" required>
        </div>

        <div class="form-group" style="margin-bottom: 0;">
          <label class="form-label">Supabase Anon Key</label>
          <input type="text" id="sbKeyInput" class="form-input" placeholder="eyJhbGciOiJIUzI1NiIsInR5..." value="${currentKey}" required>
        </div>
      </div>

      <div style="background: rgba(36,161,222,0.06); border: 1px solid rgba(36,161,222,0.2); border-radius: var(--radius-md); padding: 16px; margin-bottom: 20px;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
          <h4 style="font-size: 1rem; color: #0088cc; margin: 0; display: flex; align-items: center; gap: 8px;">
            <i class="ri-telegram-fill"></i> Telegram Anlık Bildirim Botu (İsteğe Bağlı)
          </h4>
          <button type="button" class="btn btn-outline" id="testTelegramBtn" style="padding: 4px 12px; font-size: 0.8rem; border-color: #0088cc; color: #0088cc;">
            <i class="ri-send-plane-fill"></i> Test Gönder
          </button>
        </div>
        <p style="color: var(--text-muted); font-size: 0.82rem; margin-bottom: 12px; line-height: 1.4;">
          Müşteri teklif formu gönderdiğinde cebinize anında Telegram bildirimi gelir. Telegram'da <strong>@BotFather</strong>'dan bot oluşturup token alabilir, <strong>@userinfobot</strong>'tan ID'nizi öğrenebilirsiniz.
        </p>

        <div class="form-group">
          <label class="form-label">Telegram Bot Token</label>
          <input type="text" id="tgTokenInput" class="form-input" placeholder="Örn: 7123456789:AAH..." value="${currentTelegramToken}">
        </div>

        <div class="form-group" style="margin-bottom: 0;">
          <label class="form-label">Telegram Chat ID (Kullanıcı / Grup ID)</label>
          <input type="text" id="tgChatIdInput" class="form-input" placeholder="Örn: 123456789" value="${currentTelegramChatId}">
        </div>
      </div>

      <div style="display: flex; gap: 12px; margin-top: 24px;">
        <button type="button" class="btn btn-outline w-100" id="closeSbConfigBtn">İptal</button>
        <button type="submit" class="btn btn-primary w-100"><i class="ri-save-line"></i> Tüm Ayarları Kaydet</button>
      </div>
    </form>
  `;

  backdrop.classList.add('active');

  document.getElementById('closeSbConfigBtn')?.addEventListener('click', () => backdrop.classList.remove('active'));

  document.getElementById('testTelegramBtn')?.addEventListener('click', async () => {
    const token = document.getElementById('tgTokenInput').value.trim();
    const chatId = document.getElementById('tgChatIdInput').value.trim();
    if (!token || !chatId) {
      alert('Lütfen önce Telegram Bot Token ve Chat ID alanlarını doldurunuz.');
      return;
    }
    const btn = document.getElementById('testTelegramBtn');
    btn.disabled = true;
    btn.innerHTML = '<i class="ri-loader-4-line"></i> Gönderiliyor...';
    const res = await testTelegramNotification(token, chatId);
    btn.disabled = false;
    btn.innerHTML = '<i class="ri-send-plane-fill"></i> Test Gönder';
    if (res.ok) {
      alert('🎉 Telegram test bildirimi başarıyla gönderildi! Telegram uygulamanızı kontrol edin.');
    } else {
      alert(`⚠️ Telegram testi başarısız: ${res.error || (res.data && res.data.description) || 'Bilinmeyen hata'}`);
    }
  });

  document.getElementById('supabaseConfigForm')?.addEventListener('submit', (e) => {
    e.preventDefault();
    const url = document.getElementById('sbUrlInput').value.trim();
    const key = document.getElementById('sbKeyInput').value.trim();
    const tgToken = document.getElementById('tgTokenInput').value.trim();
    const tgChatId = document.getElementById('tgChatIdInput').value.trim();

    if (tgToken) {
      localStorage.setItem('yk_telegram_bot_token', tgToken);
    } else {
      localStorage.removeItem('yk_telegram_bot_token');
    }

    if (tgChatId) {
      localStorage.setItem('yk_telegram_chat_id', tgChatId);
    } else {
      localStorage.removeItem('yk_telegram_chat_id');
    }

    if (initSupabaseConfig(url, key)) {
      backdrop.classList.remove('active');
      alert('⚡ Bulut ve Bildirim Ayarları Başarıyla Kaydedildi!');
      store.initCloudSync();
      renderAdminDashboard();
    }
  });
}

function openDeleteConfirmModal(reqItem) {
  const backdrop = document.getElementById('modalBackdrop');
  const modalBody = document.getElementById('modalBody');
  if (!backdrop || !modalBody) return;

  modalBody.innerHTML = `
    <div style="text-align: center; padding: 12px 0;">
      <div style="width: 56px; height: 56px; border-radius: 50%; background: #FFEBEE; color: #C62828; display: flex; align-items: center; justify-content: center; font-size: 1.8rem; margin: 0 auto 16px;">
        <i class="ri-delete-bin-fill"></i>
      </div>
      <h3 style="font-size: 1.35rem; color: var(--text-dark); margin-bottom: 8px;">Teklif Talebi Silinsin mi?</h3>
      <p style="color: var(--text-muted); font-size: 0.9rem; margin-bottom: 24px; line-height: 1.5;">
        <strong>${reqItem.fullName}</strong> isimli müşteriye ait <strong>${reqItem.eventTypeName}</strong> teklif talebi kalıcı olarak silinecektir.
      </p>

      <div style="display: flex; gap: 12px; justify-content: center;">
        <button class="btn btn-outline" id="cancelDeleteBtn" style="padding: 10px 24px;">İptal</button>
        <button class="btn btn-primary" id="confirmDeleteBtn" style="background: #C62828; border-color: #C62828; padding: 10px 24px;">Evet, Sil</button>
      </div>
    </div>
  `;

  backdrop.classList.add('active');

  const handleCancel = (e) => {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    backdrop.classList.remove('active');
  };

  const handleConfirm = (e) => {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    if (isDeletingEventRequest) return;

    isDeletingEventRequest = true;
    backdrop.classList.remove('active');

    store.deleteEventRequest(reqItem.id);
    isDeletingEventRequest = false;

    renderAdminDashboard();
  };

  document.getElementById('cancelDeleteBtn')?.addEventListener('click', handleCancel);
  document.getElementById('confirmDeleteBtn')?.addEventListener('click', handleConfirm);
}

function openAdisyonModal(tableId) {
  const backdrop = document.getElementById('modalBackdrop');
  const modalBody = document.getElementById('modalBody');
  if (!backdrop || !modalBody) return;

  const table = store.tables.find(t => t.id === tableId);
  const adisyon = store.adisyons[tableId] || { items: [], total: 0 };

  modalBody.innerHTML = `
    <h3 style="margin-bottom: 4px; font-size: 1.5rem; color: var(--emerald-dark);">${table ? table.name : tableId} Adisyon Detayı</h3>
    <p style="color: var(--text-muted); font-size: 0.88rem; margin-bottom: 20px;">Masa hesabı ve yetkili sipariş yönetimi</p>

    <div style="max-height: 240px; overflow-y: auto; margin-bottom: 20px; border-top: 1px solid var(--border-light); border-bottom: 1px solid var(--border-light); padding: 12px 0;">
      ${(!adisyon.items || adisyon.items.length === 0) ? `
        <p style="text-align: center; color: var(--text-muted); padding: 20px 0;">Henüz masaya ürün eklenmedi.</p>
      ` : `
        <table style="width: 100%; border-collapse: collapse; font-size: 0.9rem;">
          <thead>
            <tr style="text-align: left; border-bottom: 1px solid var(--border-light); color: var(--text-muted);">
              <th style="padding: 6px 0;">Ürün</th>
              <th style="padding: 6px 0; text-align: center;">Adet</th>
              <th style="padding: 6px 0; text-align: right;">Fiyat</th>
              <th style="padding: 6px 0; text-align: right;">İşlem</th>
            </tr>
          </thead>
          <tbody>
            ${adisyon.items.map((item, idx) => `
              <tr style="border-bottom: 1px dashed var(--border-light);">
                <td style="padding: 10px 0; font-weight: 600;">${item.name}</td>
                <td style="padding: 10px 0; text-align: center;">${item.qty}</td>
                <td style="padding: 10px 0; text-align: right; color: var(--emerald-main); font-weight: 700;">₺${(item.price * item.qty).toFixed(2)}</td>
                <td style="padding: 10px 0; text-align: right;">
                  <button class="remove-item-btn" data-index="${idx}" data-product-id="${item.id}" style="color: #D9534F; font-size: 1rem;"><i class="ri-delete-bin-line"></i></button>
                </td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      `}
    </div>

    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; background: rgba(19,75,59,0.06); padding: 12px 16px; border-radius: var(--radius-md);">
      <span style="font-weight: 700; font-size: 1.1rem;">Toplam Tutar:</span>
      <span style="font-size: 1.4rem; font-weight: 800; color: var(--emerald-dark);">₺${(adisyon.total || 0).toFixed(2)}</span>
    </div>

    <div class="form-group" style="margin-bottom: 20px;">
      <label class="form-label">Masaya Ürün Ekle</label>
      <select id="quickAddProductSelect" class="form-input">
        <option value="" disabled selected>Ürün Seçiniz...</option>
        ${store.products.filter(p => !p.isOutOfStock).map(p => `
          <option value="${p.id}">${p.name} - ₺${p.price}</option>
        `).join('')}
      </select>
    </div>

    <div style="display: flex; gap: 12px;">
      <button class="btn btn-outline w-100" id="closeAdisyonBtn" style="border-color: #D9534F; color: #D9534F;">
        <i class="ri-check-line"></i> Hesabı Kapat
      </button>
      <button class="btn btn-primary w-100" id="addSelectedProductBtn">
        <i class="ri-add-circle-line"></i> Ürünü Ekle
      </button>
    </div>
  `;

  backdrop.classList.add('active');

  modalBody.querySelectorAll('.remove-item-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const idx = e.currentTarget.getAttribute('data-index');
      const prodId = e.currentTarget.getAttribute('data-product-id');
      store.removeAdisyonItem(tableId, idx !== null ? Number(idx) : prodId);
      openAdisyonModal(tableId);
    });
  });

  document.getElementById('addSelectedProductBtn')?.addEventListener('click', () => {
    const sel = document.getElementById('quickAddProductSelect');
    if (sel && sel.value) {
      store.addItemToAdisyon(tableId, sel.value, 1, true);
      openAdisyonModal(tableId);
    }
  });

  document.getElementById('closeAdisyonBtn')?.addEventListener('click', () => {
    const tableName = table ? table.name : tableId;
    if (confirm(`${tableName} hesabını kapatıp masayı boşaltmak istiyor musunuz?`)) {
      store.closeAdisyon(tableId);
      backdrop.classList.remove('active');
      renderAdminDashboard();
    }
  });
}

function openStockModal() {
  activeAdminTab = 'menu_mgmt';
  renderAdminDashboard();
}

// 1. ÜRÜN EKLEME & DÜZENLEME MODALI (FILE UPLOAD + URL INPUT + LIVE PREVIEW)
function openEditProductModal(productId = null) {
  const backdrop = document.getElementById('modalBackdrop');
  const modalBody = document.getElementById('modalBody');
  if (!backdrop || !modalBody) return;

  const isNew = !productId;
  const product = isNew ? null : store.products.find(p => p.id == productId);
  if (!isNew && !product) return;

  const currentName = product ? product.name : '';
  const currentPrice = product ? product.price : '';
  const currentCat = product ? product.category : (store.categories[0]?.name || 'Sıcak İçecekler');
  const currentDesc = product ? (product.desc || '') : '';
  const currentImg = product ? (product.imageUrl || product.image || './src/assets/images/hero-coffee.jpg') : './src/assets/images/hero-coffee.jpg';

  const modalTitle = isNew
    ? `<i class="ri-add-circle-line" style="color: var(--emerald-main);"></i> Menüye Yeni Ürün Ekle`
    : `<i class="ri-edit-circle-line" style="color: var(--emerald-main);"></i> Ürün Bilgilerini & Görselini Düzenle`;

  const btnText = isNew
    ? `<i class="ri-add-line"></i> Ürünü Menüye Ekle`
    : `<i class="ri-save-line"></i> Değişiklikleri Kaydet`;

  modalBody.innerHTML = `
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
      <h3 style="font-size: 1.4rem; color: var(--emerald-dark); margin: 0;">${modalTitle}</h3>
    </div>
    <p style="color: var(--text-muted); font-size: 0.88rem; margin-bottom: 20px;">
      ${isNew ? 'Menüde yer alacak yeni ürünün bilgilerini ve fotoğrafını giriniz.' : 'Cihazınızdan yeni resim yükleyin veya internet resim URL\'si girin.'}
    </p>

    <form id="editProductForm">
      <div style="display: flex; gap: 16px; margin-bottom: 16px; flex-wrap: wrap;">
        <div style="flex: 2; min-width: 200px;">
          <label class="form-label">Ürün Adı *</label>
          <input type="text" id="editProductName" class="form-input" value="${currentName}" placeholder="Örn: Dağ Çilekli Cheesecake" required>
        </div>
        <div style="flex: 1; min-width: 120px;">
          <label class="form-label">Fiyat (₺) *</label>
          <input type="number" step="0.5" id="editProductPrice" class="form-input" value="${currentPrice}" placeholder="120" required>
        </div>
      </div>

      <div class="form-group" style="margin-bottom: 16px;">
        <label class="form-label">Kategori *</label>
        <select id="editProductCategory" class="form-input" style="height: 48px;">
          ${store.categories.map(cat => `
            <option value="${cat.name}" ${currentCat === cat.name ? 'selected' : ''}>${cat.emoji} ${cat.name}</option>
          `).join('')}
          ${!store.categories.some(c => c.name === currentCat) && currentCat ? `
            <option value="${currentCat}" selected>${currentCat}</option>
          ` : ''}
          <option value="Diğer" ${currentCat === 'Diğer' ? 'selected' : ''}>🍽️ Diğer</option>
        </select>
      </div>

      <div class="form-group" style="margin-bottom: 16px;">
        <label class="form-label">Açıklama (İçerik, porsiyon vb.)</label>
        <textarea id="editProductDesc" class="form-textarea" rows="2" placeholder="Örn: Taze mevsim çilekleri ve özel mascarpone peyniri ile...">${currentDesc}</textarea>
      </div>

      <!-- File Upload & Drag-Drop Zone -->
      <div class="form-group" style="margin-bottom: 16px;">
        <label class="form-label">Bilgisayar / Telefondan Resim Yükle (Drag & Drop)</label>
        <input type="file" id="editProductFileInput" accept="image/*" style="display: none;">
        <div id="dragDropZone" class="drag-drop-area">
          <i class="ri-upload-cloud-2-line" style="font-size: 2.2rem; display: block; margin-bottom: 6px; color: var(--emerald-main);"></i>
          <span>Resim Dosyasını Buraya Sürükleyin veya <strong style="color: var(--emerald-main); text-decoration: underline;">Dosya Seçin</strong></span>
        </div>
      </div>

      <div class="form-group" style="margin-bottom: 16px;">
        <label class="form-label">veya İnternet Resim URL'si Yapıştırın</label>
        <input type="text" id="editProductImageUrl" class="form-input" value="${isNew ? '' : currentImg}" placeholder="https://images.unsplash.com/...">
      </div>

      <!-- Live Image Preview Box -->
      <div style="margin-bottom: 16px; padding: 12px; background: var(--bg-cream); border-radius: var(--radius-md); border: 1px solid var(--border-light); text-align: center;">
        <div style="font-size: 0.8rem; font-weight: 700; color: var(--text-muted); margin-bottom: 8px;">🖼️ GÖRSEL CANLI ÖNİZLEME</div>
        <img id="editProductImagePreview" src="${currentImg}" alt="Önizleme" style="max-height: 140px; max-width: 100%; border-radius: var(--radius-sm); object-fit: cover; border: 1px solid var(--border-light);" onerror="this.onerror=null;this.src='./src/assets/images/hero-coffee.jpg';">
      </div>

      <!-- Sticky Modal Footer Buttons -->
      <div class="modal-footer">
        <button type="button" class="btn btn-outline w-100" id="cancelEditProductBtn">İptal</button>
        <button type="submit" class="btn btn-accent w-100">${btnText}</button>
      </div>
    </form>
  `;

  backdrop.classList.add('active');

  const fileInput = document.getElementById('editProductFileInput');
  const dropZone = document.getElementById('dragDropZone');
  const urlInput = document.getElementById('editProductImageUrl');
  const imgPreview = document.getElementById('editProductImagePreview');

  const processImageFile = (file) => {
    if (!file || !file.type.startsWith('image/')) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      const dataUrl = e.target.result;
      if (urlInput) urlInput.value = dataUrl;
      if (imgPreview) imgPreview.src = dataUrl;
    };
    reader.readAsDataURL(file);
  };

  if (dropZone && fileInput) {
    dropZone.addEventListener('click', () => fileInput.click());

    fileInput.addEventListener('change', (e) => {
      if (e.target.files && e.target.files[0]) processImageFile(e.target.files[0]);
    });

    dropZone.addEventListener('dragover', (e) => {
      e.preventDefault();
      dropZone.classList.add('drag-over');
    });

    dropZone.addEventListener('dragleave', () => dropZone.classList.remove('drag-over'));

    dropZone.addEventListener('drop', (e) => {
      e.preventDefault();
      dropZone.classList.remove('drag-over');
      if (e.dataTransfer.files && e.dataTransfer.files[0]) {
        processImageFile(e.dataTransfer.files[0]);
      }
    });
  }

  if (urlInput && imgPreview) {
    urlInput.addEventListener('input', (e) => {
      const val = e.target.value.trim();
      imgPreview.src = val || './src/assets/images/hero-coffee.jpg';
    });
  }

  document.getElementById('cancelEditProductBtn')?.addEventListener('click', () => {
    backdrop.classList.remove('active');
    renderAdminDashboard();
  });

  document.getElementById('editProductForm')?.addEventListener('submit', (e) => {
    e.preventDefault();
    const newName = document.getElementById('editProductName').value.trim();
    const newPrice = Number(document.getElementById('editProductPrice').value) || 0;
    const newCategory = document.getElementById('editProductCategory').value;
    const newDesc = document.getElementById('editProductDesc').value.trim();
    const newImgUrl = document.getElementById('editProductImageUrl').value.trim() || './src/assets/images/hero-coffee.jpg';

    if (!newName) {
      alert('Lütfen ürün adını giriniz.');
      return;
    }

    if (isNew) {
      store.addProduct({
        name: newName,
        price: newPrice,
        category: newCategory,
        desc: newDesc,
        imageUrl: newImgUrl,
        image: newImgUrl
      });
      backdrop.classList.remove('active');
      if (typeof showToast === 'function') {
        showToast(`✅ "${newName}" menüye başarıyla eklendi!`);
      }
    } else {
      store.updateProduct(productId, {
        name: newName,
        price: newPrice,
        category: newCategory,
        desc: newDesc,
        imageUrl: newImgUrl,
        image: newImgUrl
      });
      backdrop.classList.remove('active');
      if (typeof showToast === 'function') {
        showToast(`✅ "${newName}" bilgileri başarıyla güncellendi!`);
      }
    }

    renderAdminDashboard();
  });
}


let takeawayFilterStatus = 'all';

function renderTakeawayOrdersView() {
  const orders = store.onlineOrders || [];
  const filtered = orders.filter(o => takeawayFilterStatus === 'all' || o.status === takeawayFilterStatus);

  const statusLabels = {
    new: { text: 'Yeni Sipariş', bg: '#D4AF37', color: '#000', icon: 'ri-time-line' },
    preparing: { text: 'Hazırlanıyor', bg: '#E67E22', color: '#fff', icon: 'ri-fire-line' },
    on_the_way: { text: 'Kuryede / Yolda', bg: '#8E44AD', color: '#fff', icon: 'ri-e-bike-2-line' },
    completed: { text: 'Tamamlandı', bg: '#2E7D32', color: '#fff', icon: 'ri-checkbox-circle-line' },
    cancelled: { text: 'İptal Edildi', bg: '#D9534F', color: '#fff', icon: 'ri-close-circle-line' }
  };

  const cardsHtml = filtered.length === 0 ? `
    <div style="grid-column: 1 / -1; text-align: center; padding: 48px; background: var(--bg-card); border-radius: var(--radius-md); border: 1px solid var(--border-light); color: var(--text-muted);">
      <i class="ri-inbox-archive-line" style="font-size: 3rem; display: block; margin-bottom: 12px;"></i>
      Henüz bu filtreye uygun paket sipariş bulunmamaktadır.
    </div>
  ` : filtered.map(order => {
    const st = statusLabels[order.status] || statusLabels.new;
    const isDelivery = order.orderType === 'delivery';

    const itemsRows = (order.items || []).map(i => `
      <div style="display: flex; justify-content: space-between; font-size: 0.88rem; padding: 4px 0; border-bottom: 1px dashed rgba(0,0,0,0.06);">
        <span><strong>${i.qty}x</strong> ${i.name}</span>
        <span style="font-weight: 700;">₺${(i.price * i.qty).toFixed(2)}</span>
      </div>
    `).join('');

    return `
      <div class="takeaway-order-card" style="background: var(--bg-card); border-radius: var(--radius-md); border: 1px solid var(--border-light); padding: 20px; box-shadow: var(--shadow-sm); position: relative; border-left: 5px solid ${st.bg};">
        <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 12px; flex-wrap: wrap; gap: 8px;">
          <div>
            <div style="font-size: 1.1rem; font-weight: 800; color: var(--emerald-dark); display: flex; align-items: center; gap: 8px;">
              <span>${order.id}</span>
              <span style="font-size: 0.8rem; padding: 3px 10px; border-radius: 99px; background: ${isDelivery ? 'rgba(19,75,59,0.1)' : 'rgba(212,175,55,0.15)'}; color: ${isDelivery ? 'var(--emerald-main)' : 'var(--gold-accent)'}; font-weight: 700;">
                ${isDelivery ? '🛵 Eve Teslimat' : '🛍️ Gel-Al'}
              </span>
            </div>
            <div style="font-size: 0.8rem; color: var(--text-muted); margin-top: 2px;"><i class="ri-time-line"></i> ${order.createdAt}</div>
          </div>
          <span style="background: ${st.bg}; color: ${st.color}; font-size: 0.8rem; font-weight: 800; padding: 4px 12px; border-radius: var(--radius-full); display: inline-flex; align-items: center; gap: 4px;">
            <i class="${st.icon}"></i> ${st.text}
          </span>
        </div>

        <div style="background: rgba(19,75,59,0.03); border-radius: var(--radius-sm); padding: 12px; margin-bottom: 14px; font-size: 0.9rem;">
          <div style="font-weight: 700; color: var(--emerald-dark);"><i class="ri-user-line"></i> Müşteri: ${order.customerName}</div>
          <div style="margin-top: 4px;">
            <i class="ri-phone-line"></i> Tel: <a href="tel:${order.phone.replace(/\s+/g, '')}" style="color: var(--emerald-main); font-weight: 700; text-decoration: underline;">${order.phone}</a>
          </div>
          <div style="margin-top: 4px; color: var(--text-dark);">
            <i class="${isDelivery ? 'ri-map-pin-line' : 'ri-time-line'}"></i> ${isDelivery ? 'Adres:' : 'Gel-Al Saati:'} <strong>${order.address}</strong>
          </div>
          <div style="margin-top: 4px; color: var(--text-muted);">
            <i class="ri-bank-card-line"></i> Ödeme: <strong>${order.paymentMethodName || order.paymentMethod}</strong>
          </div>
          ${order.orderNote ? `<div style="margin-top: 6px; background: rgba(212,175,55,0.15); padding: 6px 10px; border-radius: 4px; font-size: 0.85rem; color: #856404;"><strong>📝 Sipariş Notu:</strong> ${order.orderNote}</div>` : ''}
        </div>

        <div style="margin-bottom: 14px;">
          <div style="font-size: 0.85rem; font-weight: 700; color: var(--text-muted); margin-bottom: 6px;">SİPARİŞ VERİLEN ÜRÜNLER</div>
          ${itemsRows}
          <div style="display: flex; justify-content: space-between; font-weight: 800; font-size: 1.1rem; color: var(--emerald-dark); margin-top: 10px; padding-top: 6px; border-top: 2px solid var(--border-light);">
            <span>TOPLAM TUTAR:</span>
            <span style="color: var(--gold-accent);">₺${Number(order.total).toFixed(2)}</span>
          </div>
        </div>

        <div style="display: flex; gap: 8px; flex-wrap: wrap; border-top: 1px solid var(--border-light); padding-top: 12px;">
          <button class="btn btn-outline btn-status-change" data-id="${order.id}" data-status="preparing" style="font-size: 0.78rem; padding: 6px 10px; border-color: #E67E22; color: #E67E22;" ${order.status === 'preparing' ? 'disabled' : ''}>
            <i class="ri-fire-line"></i> Hazırlanıyor
          </button>
          <button class="btn btn-outline btn-status-change" data-id="${order.id}" data-status="on_the_way" style="font-size: 0.78rem; padding: 6px 10px; border-color: #8E44AD; color: #8E44AD;" ${order.status === 'on_the_way' ? 'disabled' : ''}>
            <i class="ri-e-bike-2-line"></i> Kuryede
          </button>
          <button class="btn btn-outline btn-status-change" data-id="${order.id}" data-status="completed" style="font-size: 0.78rem; padding: 6px 10px; border-color: #2E7D32; color: #2E7D32;" ${order.status === 'completed' ? 'disabled' : ''}>
            <i class="ri-checkbox-circle-line"></i> Tamamla
          </button>
          <button class="btn btn-outline btn-status-change" data-id="${order.id}" data-status="cancelled" style="font-size: 0.78rem; padding: 6px 10px; border-color: #D9534F; color: #D9534F;" ${order.status === 'cancelled' ? 'disabled' : ''}>
            <i class="ri-close-circle-line"></i> İptal
          </button>
          <button class="btn btn-outline btn-delete-online-order" data-id="${order.id}" style="font-size: 0.78rem; padding: 6px 10px; margin-left: auto; border-color: #777; color: #777;" title="Sil">
            <i class="ri-delete-bin-line"></i>
          </button>
        </div>
      </div>
    `;
  }).join('');

  return `
    <div style="margin-bottom: 24px;">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; flex-wrap: wrap; gap: 12px;">
        <h3 style="font-size: 1.5rem; color: var(--emerald-dark); display: flex; align-items: center; gap: 8px;">
          <i class="ri-e-bike-2-line" style="color: var(--gold-accent);"></i> Paket Sipariş & Gel-Al Yönetimi
        </h3>

        <div style="display: flex; gap: 6px; flex-wrap: wrap;">
          <button class="btn ${takeawayFilterStatus === 'all' ? 'btn-primary' : 'btn-outline'} btn-takeaway-filter" data-status="all" style="font-size: 0.82rem; padding: 6px 12px;">Tümü (${orders.length})</button>
          <button class="btn ${takeawayFilterStatus === 'new' ? 'btn-primary' : 'btn-outline'} btn-takeaway-filter" data-status="new" style="font-size: 0.82rem; padding: 6px 12px; border-color: #D4AF37;">Yeni (${orders.filter(o => o.status === 'new').length})</button>
          <button class="btn ${takeawayFilterStatus === 'preparing' ? 'btn-primary' : 'btn-outline'} btn-takeaway-filter" data-status="preparing" style="font-size: 0.82rem; padding: 6px 12px;">Hazırlanıyor (${orders.filter(o => o.status === 'preparing').length})</button>
          <button class="btn ${takeawayFilterStatus === 'on_the_way' ? 'btn-primary' : 'btn-outline'} btn-takeaway-filter" data-status="on_the_way" style="font-size: 0.82rem; padding: 6px 12px;">Kuryede (${orders.filter(o => o.status === 'on_the_way').length})</button>
          <button class="btn ${takeawayFilterStatus === 'completed' ? 'btn-primary' : 'btn-outline'} btn-takeaway-filter" data-status="completed" style="font-size: 0.82rem; padding: 6px 12px;">Tamamlanan (${orders.filter(o => o.status === 'completed').length})</button>
        </div>
      </div>

      <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(340px, 1fr)); gap: 20px;">
        ${cardsHtml}
      </div>
    </div>
  `;
}
